import { GeoJsonProperties, LineString, Position } from "geojson";
import { HlaWayType, hlaWayTypeIsRoad } from "../../../../hla/models/HlaWay";
import { categorizeCompositeFeature } from "../../../utils/query/categorizeCompositeFeature";
import turf from "../../../../shared/utils/turf";
import { delay } from "@keita/lanepatrol-sdk";
import { findAndRegisterOsmData } from "./findAndRegisterOsmData";
import { HlaWayBuilder } from "../models/HlaWayBuilder";
import { findAndRegisterAdjacentFeatures } from "../../../utils/query/findAndRegisterAdjacentFeatures";

export async function createWayFromLineFeature(
  featureId: number,
  coordinates: Position[],
  properties: GeoJsonProperties,
  enabledCategories: HlaWayType[],
  map: mapboxgl.Map,
  rightHandTraffic: boolean,
) {
  const props = properties!;
  const type = props.type ?? "";
  const className = props.class ?? "";

  var categoryName = categorizeCompositeFeature(className, type);

  if (!enabledCategories.includes(categoryName)) {
    return;
  }

  const lineString: LineString = {
    type: "LineString",
    coordinates,
  };

  console.log("Waiting and moving...");
  const featureCenter = turf.centroid(lineString);
  map.jumpTo({
    center: featureCenter.geometry.coordinates as mapboxgl.LngLatLike,
    zoom: 16,
  });
  await delay(200);

  const builder = new HlaWayBuilder(
    props.name,
    categoryName,
    coordinates,
    rightHandTraffic,
  );

  console.log("Importing", categoryName, props);

  builder.oneWay = props.oneway === "true";

  if (!!props.bike_lane && props.bike_lane !== "no") {
    if (props.bike_lane !== "left") {
      builder.right.cycleLane = "lane";
    }

    if (props.bike_lane !== "right") {
      builder.left.cycleLane = "lane";
    }
  }

  if (hlaWayTypeIsRoad(categoryName)) {
    builder.nRoadLanes = builder.oneWay ? 1 : 2;
  }

  findAndRegisterAdjacentFeatures(featureId, lineString, map, builder);

  findAndRegisterOsmData(builder, map);

  const way = builder.toCreateHlaWay();

  return way;
}
